import React from 'react';
import { SvgIcon, Typography } from '@material-ui/core';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import { useStyle } from './lisence-types.style';
import { useTranslation } from 'react-i18next';

type Props = {
    types: string[];
};

export const DriverLisences: React.FC<Props> = ({ types }) => {
    const classes = useStyle();
    const { t } = useTranslation();

    return (
        <li className={classes.content}>
            <SvgIcon className={classes.icon} color="primary">
                <DriveEtaIcon />
            </SvgIcon>
            <div>
                <Typography className={classes.title}>{t('jobDetails:driverLicenseTypes')}</Typography>

                <div className={classes.types}>
                    {types &&
                        types.map((type, index) => {
                            return <p key={index}>{type}</p>;
                        })}
                </div>
            </div>
        </li>
    );
};
